module.exports = __webpack_public_path__ + "static/media/4.17b171c6.png";